import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { ConnectionDetailProps } from '@/lib/types';

export const ConnectionDetail = ({
  connectedDate,
  accountId,
  apiKey,
  accountIdLabel = 'Account ID',
  accountNameLabel = 'Account Name',
}: ConnectionDetailProps) => {
  return (
    <Card className='w-full border-none shadow-none p-0'>
      <CardHeader>
        <p className='text-gray-500'>Successfully connected on {connectedDate}</p>
      </CardHeader>
      <CardContent className='space-y-6'>
        <div className='space-y-2'>
          <label className='text-base font-medium'>{accountIdLabel}</label>
          <Input value={accountId} readOnly className='bg-gray-50 !ring !ring-transparent' />
        </div>
        <div className='space-y-2'>
          <label className='text-base font-medium'>{accountNameLabel}</label>
          <Input value={apiKey} readOnly className='bg-gray-50 font-mono !ring !ring-transparent' />
        </div>
      </CardContent>
    </Card>
  );
};
